
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motivation-scan",
      function () {
        return require("private-next-pages/motivation-scan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motivation-scan"])
      });
    }
  